import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalKasirCreatePage } from './modal-kasir-create.page';

const routes: Routes = [
  {
    path: '',
    component: ModalKasirCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalKasirCreatePageRoutingModule {}
